import { useCallback, useSyncExternalStore } from "react";
import { t, getLocale, setLocaleInternal, getSupportedLocales, } from "./translator";
var subscribers = new Set();
function subscribe(callback) {
    subscribers.add(callback);
    return function () { return subscribers.delete(callback); };
}
function getSnapshot() {
    return getLocale();
}
function notifySubscribers() {
    subscribers.forEach(function (callback) { return callback(); });
}
export function setLocale(locale) {
    setLocaleInternal(locale);
    notifySubscribers();
}
export function useTranslation() {
    var locale = useSyncExternalStore(subscribe, getSnapshot);
    var translate = useCallback(function (key, interpolations) {
        return t(key, interpolations);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locale]);
    return {
        translate: translate,
        locale: locale,
        setLocale: setLocale,
        locales: getSupportedLocales(),
    };
}
